import { BuyButton } from "@/components/ProductCard";
import { Star } from "@phosphor-icons/react";

export function AtAGlance({ products, labels }) {
  const picks = products.filter((p) => labels[p.id]).slice(0, 4);
  if (!picks.length) return null;
  return (
    <section data-testid="at-a-glance" className="max-w-4xl mx-auto px-6 lg:px-10 -mt-2 mb-12">
      <div className="rounded-3xl border border-[#E5E0D8] bg-white p-5 sm:p-7 shadow-[0_10px_30px_rgba(44,43,41,0.06)]">
        <p className="text-xs uppercase tracking-[0.2em] text-[#D17A58] font-semibold mb-4">Our picks at a glance</p>
        <ul className="divide-y divide-[#E5E0D8]">
          {picks.map((p) => (
            <li key={p.id} data-testid={`glance-${p.id}`} className="py-3 flex items-center gap-4">
              <img src={p.image_url} alt="" className="w-14 h-14 rounded-xl object-cover shrink-0" />
              <div className="min-w-0 flex-1">
                <p className="text-[11px] uppercase tracking-wider font-bold text-[#5B7B53]">{labels[p.id]}</p>
                <a href={`#item-${p.id}`} className="block text-sm sm:text-base font-semibold text-[#2C2B29] truncate hover:text-[#5B7B53]">{p.title}</a>
                <p className="text-xs text-[#5C5A56] flex items-center gap-1"><Star size={11} weight="fill" className="text-[#D17A58]" />{p.rating} · {p.price}</p>
              </div>
              <BuyButton product={p} testid={`glance-buy-${p.id}`} className="hidden sm:inline-flex !px-3 !py-2 text-xs" />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
